import React from "react";
import { CardTheme } from "./types";

interface CardBackProps {
  theme: CardTheme;
}

export const CardBack: React.FC<CardBackProps> = React.memo(({ theme }) => {
  const { width, height, radius } = theme.card;
  const centerX = width / 2;
  const centerY = height / 2;

  return (
    <g>
      {/* Card background */}
      <rect
        x={0}
        y={0}
        width={width}
        height={height}
        rx={radius}
        ry={radius}
        fill="#1a1a1a"
      />

      {/* Border */}
      <rect
        x={radius * 0.5}
        y={radius * 0.5}
        width={width - radius}
        height={height - radius}
        rx={radius * 0.75}
        ry={radius * 0.75}
        fill="none"
        stroke="#333"
        strokeWidth={radius * 0.3}
      />

      {/* Center logo/design - UNO text */}
      <text
        x={centerX}
        y={centerY}
        fontSize={width * 0.2}
        fontWeight="bold"
        fill="#ffffff"
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="Arial, sans-serif"
        letterSpacing={width * 0.02}
      >
        UNO
      </text>

      {/* Decorative circles */}
      <circle
        cx={centerX - width * 0.15}
        cy={centerY - height * 0.15}
        r={width * 0.05}
        fill="#E53935"
        opacity={0.6}
      />
      <circle
        cx={centerX + width * 0.15}
        cy={centerY - height * 0.15}
        r={width * 0.05}
        fill="#1E88E5"
        opacity={0.6}
      />
      <circle
        cx={centerX - width * 0.15}
        cy={centerY + height * 0.15}
        r={width * 0.05}
        fill="#43A047"
        opacity={0.6}
      />
      <circle
        cx={centerX + width * 0.15}
        cy={centerY + height * 0.15}
        r={width * 0.05}
        fill="#FDD835"
        opacity={0.6}
      />
    </g>
  );
});

CardBack.displayName = "CardBack";
